import { z } from 'zod';

import type { PetitionEditPageData, PetitionEditPageState } from 'src/app/pages/petitionEditV2/pageContext';

export const tagsSchema = z.string().array();

type FormStateTags = PetitionEditPageState['formState']['tags'];
export const deserializeTags = ({ petition }: PetitionEditPageData): FormStateTags => {
	const petitionTags = petition.tagsConnection?.nodes || [];
	const value = petitionTags.map((tag: { name: string }) => tag.name);

	return {
		value,
		error: null,
		dirty: false,
	};
};
